// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8aabb93a","977":"8da0bf27"}[chunkId] + ".chunk.js";
};